import { AfterViewInit, Component, ViewChild } from '@angular/core'
import { FieldType } from '@ngx-formly/core'
import { AutoComplete } from 'primeng/autocomplete'

export interface UserProfile {
  firstName: string
  lastName: string
  userProfileImage?: string
  [key: string]: any
}

@Component({
  selector: 'basin-formly-attendees',
  templateUrl: './formly-attendees.component.html',
  styleUrls: ['./formly-attendees.component.scss'],
})
export class FormlyAttendeesComponent
  extends FieldType
  implements AfterViewInit
{
  @ViewChild('autoComplete') autoComplete: AutoComplete | any
  results: UserProfile[]
  selectedUserSelected: UserProfile

  ngAfterViewInit(): void {
    this.setKeydown()
  }

  search(event): void {
    if (!event?.query) {
      this.results = this.props.suggestions?.filter((suggestion) => {
        if (
          !this.formControl.value ||
          (this.formControl.value &&
            !this.formControl.value.includes(suggestion))
        ) {
          return suggestion
        }
      })
    } else {
      const query: string = event.query.toLowerCase()
      this.results = this.props.suggestions?.filter((suggestion) => {
        if (
          (!this.formControl.value ||
            (this.formControl.value &&
              !this.formControl.value.includes(suggestion))) &&
          (suggestion.firstName.toLowerCase().includes(query) ||
            suggestion.lastName.toLowerCase().includes(query))
        ) {
          return suggestion
        }
      })
    }
  }

  openDropdown(event) {
    if (
      event !== null &&
      event.target !== null &&
      event.target.tagName !== 'DIV'
    ) {
      event.stopPropagation()
      setTimeout(() => {
        this.autoComplete.show()
        this.search(undefined)
      }, 0)
    }
  }

  getUserInitials(firstName: string, lastName: string): string {
    let firstInitial: string = Array.from(firstName)[0]
    let LastInitial: string = Array.from(lastName)[0]
    return firstInitial.toUpperCase() + LastInitial.toUpperCase() + ''
  }

  selectedUserClicked(selectedUser: UserProfile): void {
    this.selectedUserSelected = selectedUser
  }

  setKeydown() {
    this.autoComplete.onKeydown = (event) => {
      if (this.autoComplete.overlayVisible) {
        switch (event.which) {
          //down
          case 40:
            if (this.autoComplete.group) {
              let highlightItemIndex = this.autoComplete.findOptionGroupIndex(
                this.autoComplete.highlightOption,
                this.autoComplete.suggestions
              )

              if (highlightItemIndex !== -1) {
                let nextItemIndex = highlightItemIndex.itemIndex + 1
                if (
                  nextItemIndex <
                  this.autoComplete.getOptionGroupChildren(
                    this.autoComplete.suggestions[highlightItemIndex.groupIndex]
                  ).length
                ) {
                  this.autoComplete.highlightOption =
                    this.autoComplete.getOptionGroupChildren(
                      this.autoComplete.suggestions[
                        highlightItemIndex.groupIndex
                      ]
                    )[nextItemIndex]
                  this.autoComplete.highlightOptionChanged = true
                } else if (
                  this.autoComplete.suggestions[
                    highlightItemIndex.groupIndex + 1
                  ]
                ) {
                  this.autoComplete.highlightOption =
                    this.autoComplete.getOptionGroupChildren(
                      this.autoComplete.suggestions[
                        highlightItemIndex.groupIndex + 1
                      ]
                    )[0]
                  this.autoComplete.highlightOptionChanged = true
                }
              } else {
                this.autoComplete.highlightOption =
                  this.autoComplete.getOptionGroupChildren(
                    this.autoComplete.suggestions[0]
                  )[0]
              }
            } else {
              let highlightItemIndex = this.autoComplete.findOptionIndex(
                this.autoComplete.highlightOption,
                this.autoComplete.suggestions
              )

              if (highlightItemIndex != -1) {
                let nextItemIndex = highlightItemIndex + 1
                if (nextItemIndex != this.autoComplete.suggestions.length) {
                  this.autoComplete.highlightOption =
                    this.autoComplete.suggestions[nextItemIndex]
                  this.autoComplete.highlightOptionChanged = true
                }
              } else {
                this.autoComplete.highlightOption =
                  this.autoComplete.suggestions[0]
              }
            }

            event.preventDefault()
            break

          //up
          case 38:
            if (this.autoComplete.group) {
              let highlightItemIndex = this.autoComplete.findOptionGroupIndex(
                this.autoComplete.highlightOption,
                this.autoComplete.suggestions
              )
              if (highlightItemIndex !== -1) {
                let prevItemIndex = highlightItemIndex.itemIndex - 1
                if (prevItemIndex >= 0) {
                  this.autoComplete.highlightOption =
                    this.autoComplete.getOptionGroupChildren(
                      this.autoComplete.suggestions[
                        highlightItemIndex.groupIndex
                      ]
                    )[prevItemIndex]
                  this.autoComplete.highlightOptionChanged = true
                } else if (prevItemIndex < 0) {
                  let prevGroup =
                    this.autoComplete.suggestions[
                      highlightItemIndex.groupIndex - 1
                    ]
                  if (prevGroup) {
                    this.autoComplete.highlightOption =
                      this.autoComplete.getOptionGroupChildren(prevGroup)[
                        this.autoComplete.getOptionGroupChildren(prevGroup)
                          .length - 1
                      ]
                    this.autoComplete.highlightOptionChanged = true
                  }
                }
              }
            } else {
              let highlightItemIndex = this.autoComplete.findOptionIndex(
                this.autoComplete.highlightOption,
                this.autoComplete.suggestions
              )

              if (highlightItemIndex > 0) {
                let prevItemIndex = highlightItemIndex - 1
                this.autoComplete.highlightOption =
                  this.autoComplete.suggestions[prevItemIndex]
                this.autoComplete.highlightOptionChanged = true
              }
            }

            event.preventDefault()
            break

          //enter
          case 13:
            if (this.autoComplete.highlightOption) {
              this.autoComplete.selectItem(this.autoComplete.highlightOption)
              this.autoComplete.hide()
            }
            event.preventDefault()
            break

          //escape
          case 27:
            this.autoComplete.hide()
            event.preventDefault()
            break

          //tab
          case 9:
            if (this.autoComplete.highlightOption) {
              this.autoComplete.selectItem(this.autoComplete.highlightOption)
            }
            this.autoComplete.hide()
            break
        }
      } else {
        if (event.which === 40 && this.autoComplete.suggestions) {
          this.autoComplete.search(event, event.target.value)
        } else if (
          event.ctrlKey &&
          event.key === 'z' &&
          !this.autoComplete.multiple
        ) {
          this.autoComplete.inputEL.nativeElement.value =
            this.autoComplete.resolveFieldData(null)
          this.autoComplete.value = ''
          this.autoComplete.onModelChange(this.autoComplete.value)
        } else if (
          event.ctrlKey &&
          event.key === 'z' &&
          this.autoComplete.multiple
        ) {
          this.autoComplete.value.pop()
          this.autoComplete.onModelChange(this.autoComplete.value)
          this.autoComplete.updateFilledState()
        }
      }

      if (this.autoComplete.multiple) {
        let currentSelectedIndex: number = this.autoComplete.value.indexOf(
          this.selectedUserSelected
        )
        switch (event.which) {
          //backspace or delete
          case 8:
          case 46:
            if (
              this.autoComplete.value &&
              this.autoComplete.value.length &&
              !this.autoComplete.multiInputEL.nativeElement.value
            ) {
              this.autoComplete.value = [...this.autoComplete.value]
              this.autoComplete.value.splice(currentSelectedIndex, 1)
              this.selectedUserSelected =
                this.autoComplete.value[currentSelectedIndex]
              this.autoComplete.onModelChange(this.autoComplete.value)
              this.autoComplete.updateFilledState()
              this.autoComplete.onUnselect.emit(this.selectedUserSelected)
            }
            break
          //left arrow
          case 37:
            if (
              this.autoComplete.value &&
              this.autoComplete.value.length &&
              !this.autoComplete.multiInputEL.nativeElement.value
            ) {
              this.autoComplete.value = [...this.autoComplete.value]
              if (!this.selectedUserSelected) {
                let selectedUsersLength: number = this.autoComplete.value.length
                this.selectedUserSelected =
                  this.autoComplete.value[selectedUsersLength - 1]
              } else {
                let newSelectedIndex =
                  currentSelectedIndex - 1 >= 0 ? currentSelectedIndex - 1 : 0
                this.selectedUserSelected =
                  this.autoComplete.value[newSelectedIndex]
              }
            }
            break
          //right arrow
          case 39:
            if (
              this.autoComplete.value &&
              this.autoComplete.value.length &&
              !this.autoComplete.multiInputEL.nativeElement.value
            ) {
              this.autoComplete.value = [...this.autoComplete.value]
              let selectedUsersLength: number = this.autoComplete.value.length
              let newSelectedIndex =
                currentSelectedIndex + 1 <= selectedUsersLength
                  ? currentSelectedIndex + 1
                  : selectedUsersLength
              this.selectedUserSelected =
                this.autoComplete.value[newSelectedIndex]
            }
            break
        }
      }

      this.autoComplete.inputKeyDown = true
    }
  }
}
